import { combineReducers } from 'redux';

import DashboardTypes from './types';

export const dashboardReducer = combineReducers({
  lastSales: DashboardTypes.lastSales.getReducer(),
  dashValues: DashboardTypes.dashValues.getReducer(),
  lastLeads: DashboardTypes.lastLeads.getReducer(),
  dashProducts: DashboardTypes.dashProducts.getReducer(),
  listNewzz: DashboardTypes.listNewzz.getReducer(),
  clickNewzz: DashboardTypes.clickNewzz.getReducer(),
  indications: DashboardTypes.indications.getReducer(),
  bestsellers: DashboardTypes.bestsellers.getReducer(),
  periodSalesGain: DashboardTypes.periodSalesGain.getReducer(),
  lastGain: DashboardTypes.lastGain.getReducer(),
});
